import type { PriorityTypes } from './PriorityChip.types';

export default function getPriorityColor(level: PriorityTypes) {
  switch (level) {
    case 'P1':
    case 1:
      return 'error';
    case 'P2':
    case 2:
      return 'warning';
    case 'P3':
    case 3:
      return 'info';
    case 'P4':
    case 4:
      return 'success';
    case 'P5':
    case 5:
      return 'secondary';
    default:
      return 'secondary';
  }
}
